import axios from "../../utils/axios";

const getDefaultState = () => {
    return {
        iot_data: null,
        rpmData: null,
        rpmShow: null,
        rpmOutput: null,
        rpmID: null,
        searchIOT: "",
        port_time: "",
        rpm_executed: false,
    }
}

const state = getDefaultState();

const getters = {
    iotData: (state) => state.iot_data,
    rpmData: (state) => state.rpmData,
    rpmShow: (state) => state.rpmShow,
    rpmOutput: (state) => state.rpmOutput,
    searchIOT: (state) => state.searchIOT,
    rpmID: (state) => state.rpmID,
    port_time: (state) => state.port_time,
    rpm_executed: (state) => state.rpm_executed,
};

const actions = {
    async fetchIot({commit}, data) {
        const response = await axios.get(
            "/api/v1/navplus/iot",
            {
                headers: {
                    Authorization: "Bearer" + data,
                },
            }
        );
        //console.log(response);

        function rpmFunction(p1) {
            if (p1 == true) {
                return "rpm report";
            } else {
                return "";
            }
        }

        var iot_data = response.data.data.vessels.map((p) => ({
            ...p,
            rpm_search: rpmFunction(p.devices.rpm),
        }));
        //console.log(iot_data);

        commit(
            "setIot",
            iot_data.map((item, index) => Object.assign(item, {index}))
        );
    },

    async fetchRpm({commit}, data) {
        commit("setrpmshow", true);
        const dataRpm = {
            id: data.id,
            range: data.range,
        };
        const response = await axios.post(
            "/api/v1/navplus/iot/rpm",
            dataRpm,
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );
        //console.log(response.data.data);
        commit(
            "setrpmoutput",
            response.data.data.output.map((item, index) =>
                Object.assign(item, {index})
            )
        );
        commit("setrpmdata", response.data.data);
        commit("setrpmID", data.id);
        //console.log(commit);
    },


    addrpm_executed({commit}, data) {
        commit("setrpm_executed", data)
    },

    removeRpmShow({commit}) {
        commit("setrpmoutput", null);
        commit("setrpmdata", null);
        commit("setrpmshow", null);
        commit("setrpmID", null);
    },

    inputSearchIOT({commit}, data) {
        commit("set_searchiot", data);
    },

    removeSearchIOT({commit}) {
        commit("set_searchiot", null);
    },

    set_port_time({commit}, data) {
        commit("setport_time", data);
    },

    resetIotState({commit}) {
        commit("resetState");
    },
};

const mutations = {
    setIot: (state, iot) => (state.iot_data = iot),
    setrpmdata: (state, rpmData) => (state.rpmData = rpmData),
    setrpmshow: (state, rpmShow) => (state.rpmShow = rpmShow),
    setrpmoutput: (state, rpmOutput) => (state.rpmOutput = rpmOutput),
    set_searchiot: (state, searchIOT) => (state.searchIOT = searchIOT),
    setrpmID: (state, rpmID) => (state.rpmID = rpmID),
    setport_time: (state, port_time) => (state.port_time = port_time),
    setrpm_executed: (state, rpm_executed) => (state.rpm_executed = rpm_executed),
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
